import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user?.email?.endsWith('@nimbleinc.net')) {
        navigate('/');
      } else {
        supabase.auth.signOut();
        navigate('/login?error=unauthorized');
      }
    });
  }, [navigate]);

  return (
    <div style={{display:'flex', alignItems:'center', justifyContent:'center',
                 minHeight:'100vh', background:'#f0f2f8'}}>
      <p style={{color:'#6b7280'}}>Signing you in...</p>
    </div>
  );
}
